import { Routes, Route, HashRouter } from "react-router-dom";
import Quiz from "./Quiz";

function QuizHome() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/04-11-25" element={<Quiz for={"04-11-25"} />} />
        <Route path="/04-04-25" element={<Quiz for={"04-04-25"} />} />
        <Route path="/03-21-25" element={<Quiz for={"03-21-25"} />} />
        <Route path="/03-14-25" element={<Quiz for={"03-14-25"} />} />
        <Route path="/03-07-25" element={<Quiz for={"03-07-25"} />} />
        <Route path="/02-28-25" element={<Quiz for={"02-28-25"} />} />
        <Route path="/02-21-25" element={<Quiz for={"02-21-25"} />} />
        <Route path="/02-15-25" element={<Quiz for={"02-15-25"} />} />
        <Route path="/02-16-24" element={<Quiz for={"02-16-24"} />} />
        <Route path="/12-01-23" element={<Quiz for={"12-01-23"} />} />
        <Route path="/11-17-23" element={<Quiz for={"11-17-23"} />} />
        <Route path="/11-10-23" element={<Quiz for={"11-10-23"} />} />
        <Route path="/11-03-23" element={<Quiz for={"11-03-23"} />} />
        <Route path="/stencil" element={<Quiz for={"stencil"} />} />
        <Route path="/" element={<Quiz for={"11-03-23"} />} />
      </Routes>
    </HashRouter>
  );
}
export default QuizHome;
